import React, { useEffect, useState } from "react";
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

import "./SendGiftCard.scss"
import { ReactComponent as CalendarIcon } from '../assets/images/Calendar.svg';
import { ReactComponent as EmailIcon } from '../assets/images/email.svg';
import { ReactComponent as SMSIcon } from '../assets/images/sms.svg';
import { ReactComponent as TimeNowIcon } from '../assets/images/time-now-icon.svg';
import ColseIcon from "../assets/images/modal_colse.svg"
import i18n from "../I18n"

const SEND_METHOD = {
  email: "email",
  sms: "sms",
}
const RECEIVED_MESSGAE_TYPE = {
  setCustomerName: "setCustomerName"
}

const validEmail = (email) => {
  if (!email) {
    return false;
  }
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const isValidEmail = emailRegex.test(String(email).toLowerCase());
  return isValidEmail;
};

const CustomInputWithTitle = ({
  title = "",
  onChange = () => { },
  value = "",
  placeholder = i18n.t("please_input"),
  inputType="text",
  error = false,
  errorMsg = ""
}) => {
  return (
    <div className="custom-input-with-title">
      <div className="secondary-title">{title}</div>
      <input
        className={error ? "error-input": ""}
        type={inputType}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
      <div className="field-input-error">{errorMsg}</div>
    </div>
  )
}

const CustomTextWithTitle = ({ title, content }) => {
  return (
    <div className="custom-text-with-title">
      <div className="secondary-title">{title}</div>
      <div>{content || ""}</div>
    </div>
  )
}

const getOuterSiteOrigin = () => {
  let outerOrigin = "";
  try {
    outerOrigin = window.parent.location.href;
    return outerOrigin
  } catch (e) { }
  try {
    outerOrigin = new URL(document.referrer)
    return outerOrigin.origin
  } catch (e) { }
  
  return outerOrigin;
}


const SendGiftCard = () => {
  const isOpenInOtherSite = window.top !== window
  const params = new URLSearchParams(window.location.search)

  const shopName = params.get("shop") || ""
  const brandName = shopName?.split(".")[0]?.replace("https://", "") || ""
  const targetLink = "<link>"

  const TIME_PICKER_METHOD = {
    now: "now",
    customrSelect: "customrSelect"
  }
  const [shopifyCustomerName, setShopifyCustomerName] = useState("")
  const [sendMethod, setSendMethod] = useState(SEND_METHOD.email)
  const [senderName, setSenderName] = useState("")
  const [recipientName, setRecipientName] = useState("")
  const [recipientEmail, setRecipientEmail] = useState("")
  const [recipientMobile, setRecipientMobile] = useState("")
  const [emailContent, setEmailContent] = useState("")
  const [timePickerMethod, setTimePickerMethid] = useState(TIME_PICKER_METHOD.now)
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false)
  const [sendDate, setSendDate] = useState();
  const [errorMsg, setErrorMsg] = useState({});
  useEffect(()=> {
    window.addEventListener('message', handleRecivedMessage);
    return ()=>{
      window.removeEventListener('message', handleRecivedMessage);
    }
  }, [])

  const handleRecivedMessage = (e) => {
    const { data } = e;
    if (data?.type === RECEIVED_MESSGAE_TYPE?.setCustomerName) {
      const customerName = data?.value || ""
      if (customerName !== shopifyCustomerName) {
        setShopifyCustomerName(customerName)
      }
      if (!senderName) {
        setSenderName(customerName)
      }
    }
  }

  const resetForm = () => {
    if (senderName !== shopifyCustomerName) {
      setSenderName("")
    }
    setRecipientName("")
    setRecipientEmail("")
    setRecipientMobile("")
    setEmailContent("")
    setSendDate("")
    setTimePickerMethid(TIME_PICKER_METHOD.now)
    setErrorMsg({})
    setIsDatePickerOpen(false)
  }

  const getFieldInputError = (fieldName) => {
    return errorMsg?.[fieldName] || ""
  }

  const renderSendMethodSection = () => {
    return (
      <div className="send-method-section">
        <div className="primary-title">{i18n.t("send_out_method")}</div>
        <div className="method-option">
          <div
            className={
              sendMethod === SEND_METHOD.email
                ? "primary-button"
                : "secondary-button"
            }
            onClick={() => {
              resetForm()
              setSendMethod(SEND_METHOD.email)
            }}
          >
            <EmailIcon className={sendMethod === SEND_METHOD.email ? "svg-fill-white" : "svg-fill-black"} />
            <div>{i18n.t('email')}</div>
          </div>
          <div
            className={
              sendMethod === SEND_METHOD.sms
                ? "primary-button"
                : "secondary-button"
            }
            onClick={() => {
              resetForm()
              setSendMethod(SEND_METHOD.sms)
            }}
          >
            <SMSIcon className={sendMethod === SEND_METHOD.sms ? "svg-fill-white" : "svg-fill-black"} />
            <div>{i18n.t('sms')}</div>
          </div>
        </div>
      </div>
    )
  }

  const renderSendContent = () => {
    return (
      <div className="send-content-section">
        <div className="primary-title">{i18n.t("send_out_content")}</div>
        {sendMethod === SEND_METHOD.email &&
          <CustomInputWithTitle
            title={i18n.t('sender_name')}
            value={senderName}
            onChange={(e) => {
              const { value } = e.target
              setSenderName(value)
            }}
            error={!!getFieldInputError("senderName")}
          />
        }
        <div style={{ display: "flex", gap: "8px" }}>
          <CustomInputWithTitle
            title={i18n.t('recipient_name')}
            value={recipientName}
            onChange={(e) => {
              const { value } = e.target
              setRecipientName(value)
            }}
            error={!!getFieldInputError("recipientName")}
          />
          {sendMethod === SEND_METHOD.sms ?
            <CustomInputWithTitle
              title={i18n.t('recipient_mobile')}
              value={recipientMobile}
              inputType={"number"}
              onChange={(e) => {
                const { value } = e.target
                setRecipientMobile(value)
              }}
              error={!!getFieldInputError("recipientMobile")}
            /> :
            <CustomInputWithTitle
              title={i18n.t('recipient_email')}
              value={recipientEmail}
              onChange={(e) => {
                const { value } = e.target
                setRecipientEmail(value)
              }}
              error={!!getFieldInputError("recipientEmail")}
              errorMsg={getFieldInputError("recipientEmail")}
            />}

        </div>
        {sendMethod === SEND_METHOD.sms ?
          <>
            <div className="email-content-section">
              <div className="secondary-title">{i18n.t('sms_content')}</div>
              <div style={{ whiteSpace: "pre-line" }}>
                {i18n.t("sms_content_text", {
                  senderName: senderName || "<sender's name>",
                  brandName,
                  link: targetLink
                })}
              </div>
            </div>
          </> :
          <>
            <CustomTextWithTitle
              title={i18n.t("email_subject")}
              content={i18n.t("send_gift_card_email_subject_text", { senderName: senderName || "<sender's name>", brand: brandName })}
            />
            <div className="email-content-section">
              <div className="secondary-title">{i18n.t('email_content')}</div>
              <div style={{ whiteSpace: "pre-line" }}>
                {i18n.t("send_gift_card_email_content_text", {
                  recipientName: recipientName || "<recipient's name>",
                  senderName: senderName || "<sender's name>",
                  brandName,
                  link: targetLink
                })}
              </div>
              <textarea
                placeholder={i18n.t("input_your_greeting_messgae")}
                onChange={(e) => {
                  const { value } = e.target
                  setEmailContent(value)
                }}
              />
              <div>
                {i18n.t("best_regard") + ","}<br />{senderName}
              </div>
            </div>
          </>
        }
      </div>
    )
  }

  const renderTimePickerSection = () => {
    return (
      <div className="time-picker-section">
        <div className="primary-title">{i18n.t("send_out_time")}</div>
        <div className="time-picker-method">
          <div
            className={
              timePickerMethod === TIME_PICKER_METHOD.now
                ? "primary-button" : "secondary-button"
            }
            onClick={() => {
              setTimePickerMethid(TIME_PICKER_METHOD.now)
            }}
          >
            <TimeNowIcon className={timePickerMethod === TIME_PICKER_METHOD.now ? "svg-fill-black" : "svg-fill-white"} />
            <div>{i18n.t("now")}</div>
          </div>
          <div
            style={{ position: "relative" }}
          >
            <div
              className={
                timePickerMethod === TIME_PICKER_METHOD.customrSelect
                  ? "primary-button" : "secondary-button"
              }
              onClick={() => {
                setTimePickerMethid(TIME_PICKER_METHOD.customrSelect)
                !isDatePickerOpen && setIsDatePickerOpen(true)
              }}
            >
              <CalendarIcon className={timePickerMethod === TIME_PICKER_METHOD.customrSelect ? "svg-fill-black" : "svg-fill-white"} />
              <div>
                {
                  sendDate && timePickerMethod === TIME_PICKER_METHOD.customrSelect
                    ? dayjs(sendDate).format("MMM DD,YYYY HH:mm:ss") : i18n.t("specific_date_and_time")
                }
              </div>
            </div>
            <DatePicker
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: "-1"
              }}
              onOpenChange={(open) => {
                if (!open) {
                  setIsDatePickerOpen(open)
                }
              }}
              onChange={(date, dateString) => {
                setSendDate(dateString)
                setIsDatePickerOpen(false)
              }}
              showTime
              inputReadOnly={true}
              open={isDatePickerOpen}
            />
          </div>
        </div>
      </div>
    )
  }

  const validFormData = () => {
    const newError = {};
    if (sendMethod === SEND_METHOD.sms) {
      if (!recipientName) {
        newError.recipientName = "Input is invalid!"
      }
      if (!recipientMobile) {
        newError.recipientMobile = "Input is invalid!"
      }
    }
    if (sendMethod === SEND_METHOD.email) {
      if (!senderName) {
        newError.senderName = "Input is invalid!"
      }
      if (!recipientName) {
        newError.recipientName = "Input is invalid!"
      }
      if (!recipientEmail || !validEmail(recipientEmail)) {
        newError.recipientEmail = "Please input a valid email"
      }
    }
    newError && setErrorMsg(newError);

    return Object.keys(newError).length === 0
  }

  const onClickAddToCart = () => {
    const isValid = validFormData()
    if (!isValid) {
      return;
    }
    const formDate = {
      sendMethod,
      senderName,
      sendDate: timePickerMethod === TIME_PICKER_METHOD.now ? new Date().toISOString() : new Date(sendDate).toISOString() ,
      ...(sendMethod === SEND_METHOD.sms ? {
        recipientMobile,
        smsContent: i18n.t("sms_content_text", {
          senderName,
          brandName,
          link: targetLink
        }),
      } : {
        senderName,
        recipientEmail,
        emailSubject: i18n.t("send_gift_card_email_subject_text", { senderName: senderName, brand: brandName }),
        emailContent: i18n.t("send_gift_card_email_content_text", {
          recipientName: recipientName,
          senderName,
          brandName,
          link: targetLink
        }) + "\n" + emailContent + "\n" + i18n.t("best_regard") + ",\n" + senderName,
      })
    }
    window.parent.postMessage(
      { type: "submitData", value: formDate },
      getOuterSiteOrigin()
    )
    resetForm()
  }
  return (
    <div className="send-gift-card-page">
      <div className="send-gift-card-page-header">
        <div>
          {i18n.t("send_gift_card_as_gift")}
        </div>
        {isOpenInOtherSite &&
          <img className="close-page-icon" src={ColseIcon} alt="" onClick={() => {
            resetForm();
            window.parent.postMessage(
              { type: "closePage" },
              getOuterSiteOrigin()
            );
          }} />
        }
      </div>
      <div className="send-content-form">
        {renderSendMethodSection()}
        <div className="split-line" />
        {renderSendContent()}
        <div className="split-line" />
        {renderTimePickerSection()}
      </div>
      <div className="add-to-cart-section">
        <div
          className="primary-button"
          onClick={onClickAddToCart}
        >
          {i18n.t("add_to_cart")}
        </div>
      </div>
    </div>
  )
}
export default SendGiftCard;